import { render, staticRenderFns } from "./EditDoctorInfoModal.vue?vue&type=template&id=3e5ce073"
import script from "./EditDoctorInfoModal.vue?vue&type=script&lang=js"
export * from "./EditDoctorInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports